import { IDatasourceOptions } from 'core-ts-types';
import { Datasource, IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';
import { Course } from './../builders/course_builder';

export interface ITransferPendingCoursesDatasource extends IDatasource<Course> {}

angular.module('capability-ng-transfer').factory('ngTransferPendingCoursesDatasource', function(ngCourseBuilder: typeof Course, Datasource: IDatasourceConstructor<Course>): ITransferPendingCoursesDatasource {
  const pendingCoursesDataSource: ITransferPendingCoursesDatasource = new Datasource({
    builderType: ngCourseBuilder
  });

  return pendingCoursesDataSource;
});



// WEBPACK FOOTER //
// ./app/lib/transfer/datasources/transfer_pending_courses_datasource.ts